import { createDrawerNavigator } from "@react-navigation/drawer";
import DrawerContent from "./DrawerContent";

// Screens
import Home from "../Screens/Home";
import WatchScreens from "../Screens/Watch";
import NewsScreens from "../Screens/News/";
import RacesScreens from "../Screens/Races/";
import ResultsScreens from "../Screens/Results/";
import TipsScreens from "../Screens/Tips/";
import MembersScreens from "../Screens/Members";
import AccountScreens from "../Screens/Account";
import MoreScreens from "../Screens/More/";
import TrackerScreens from "../Screens/Tracker";
import Constants from "expo-constants";
import { FunctionComponent } from "react";
import RSuspense from "../../utils/RSuspense/RSuspense";

const Drawer = createDrawerNavigator();

export type ScreenMap = {
  [key: string]: FunctionComponent;
};

function DrawerNav() {
  const createDrawerGroup = (screens: ScreenMap) => {
    return (
      <Drawer.Group>
        {Object.entries(screens).map(([name, component], index) => {
          return (
            <Drawer.Screen
              key={`${index}-${name}`}
              name={name}
              component={component}
              options={{ overlayColor: "transparent", unmountOnBlur: true }}
            />
          );
        })}
      </Drawer.Group>
    );
  };

  return (
    <RSuspense>
      <Drawer.Navigator
        initialRouteName={Constants.expoConfig.extra.INITIAL_ROUTE}
        backBehavior="history"
        useLegacyImplementation={false}
        drawerContent={(props) => <DrawerContent {...props} />}
        screenOptions={{
          header: () => null, // TODO: the header doesn't stick to the top when this isn't null.
          // need a permanent way of getting/ waiting for navigation in the Header. See https://stackoverflow.com/questions/65562835/couldnt-find-a-navigation-object-is-your-component-inside-a-screen-in-a-naviga
        }}
      >
        {createDrawerGroup(Home)}
        {createDrawerGroup(WatchScreens)}
        {createDrawerGroup(NewsScreens)}
        {createDrawerGroup(RacesScreens)}
        {createDrawerGroup(ResultsScreens)}
        {createDrawerGroup(TipsScreens)}
        {createDrawerGroup(MembersScreens)}
        {createDrawerGroup(AccountScreens)}
        {createDrawerGroup(MoreScreens)}
        {createDrawerGroup(TrackerScreens)}
      </Drawer.Navigator>
    </RSuspense>
  );
}

export default DrawerNav;
